export default __webpack_public_path__ + "static/media/simTransfer-7.84d7b22e.png";